import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { IOption, IStatusOption } from 'interfaces';

import { equipmentApi } from '../api';

export const useEquipmentFormOptions = () => {
  const translationPrefix = 'entities.equipment';
  const { t } = useTranslation();

  const [statusOptions, setStatusOptions] = useState<IStatusOption[]>([]);
  const [ivdrOptions, setIvdrOptions] = useState<IStatusOption[]>([]);
  const [warehouses, setWarehouses] = useState<IOption[]>([]);

  useEffect(() => {
    equipmentApi.getFormOptions().then(({ statusOptions, ivdrOptions, warehouses }) => {
      setStatusOptions(
        statusOptions.map((item) => ({
          ...item,
          display_name: t(`${translationPrefix}.status_options.${item.display_name}`)
        }))
      );
      setIvdrOptions(ivdrOptions);
      setWarehouses(warehouses);
    });
  }, [t]);

  return { statusOptions, ivdrOptions, warehouses };
};
